var _defs, _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path0, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRulesOnline = function SvgRulesOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "rules-online_svg__\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 135 135"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rules-online_svg__cls-2{fill:#123342}.rules-online_svg__cls-3{fill:#c1d64b}.rules-online_svg__cls-5{fill:#1697ad}.rules-online_svg__cls-6{fill:#9fb603}.rules-online_svg__cls-7{fill:#fff}.rules-online_svg__cls-8{opacity:.3}"))), /*#__PURE__*/React.createElement("rect", {
    width: 50.14,
    height: 28.55,
    x: 32.91,
    y: 51.35,
    rx: 2.6,
    ry: 2.6,
    style: {
      fill: "#a3b602"
    },
    transform: "rotate(-9.37 58.01 65.623)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.24 58.104 49.638-8.022.944 5.84-49.639 8.023z",
    className: "rules-online_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.594 61.976 18.115-2.99.404 2.447-18.115 2.99zM48.144 64.026l9.906-1.634.404 2.447-9.906 1.634zM35.636 66.086l9.906-1.635.404 2.447-9.906 1.635z",
    className: "rules-online_svg__cls-3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.65,
    height: 0.94,
    x: 37.5,
    y: 75.1,
    className: "rules-online_svg__cls-2",
    rx: 0.43,
    ry: 0.43,
    transform: "rotate(-9.37 59.345 75.56)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.05 107a4.94 4.94 0 0 1-5.59 4.19l-35.4-5.06a4.94 4.94 0 0 1-4.19-5.59l10.21-71.42a4.94 4.94 0 0 1 5.59-4.19l35.4 5.07a4.94 4.94 0 0 1 4.19 5.59Z",
    className: "rules-online_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.44 44.29h65.19v41.03H54.44z",
    style: {
      fill: "#14b0bf"
    },
    transform: "rotate(-81.86 87.032 64.812)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m91.35 66.12 2.28 8.29a1.58 1.58 0 0 1-.84 1.84c-4.07 2-18.48 6.12-28.89 5.4l.55-3.89Z",
    className: "rules-online_svg__cls-5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.92,
    height: 27.78,
    x: 79.84,
    y: 75.52,
    className: "rules-online_svg__cls-5",
    rx: 1.67,
    ry: 1.67,
    transform: "rotate(-81.87 83.805 89.412)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.92,
    height: 27.78,
    x: 80.05,
    y: 74.04,
    className: "rules-online_svg__cls-6",
    rx: 1.67,
    ry: 1.67,
    transform: "rotate(-81.87 84.014 87.936)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 85.16a1.4 1.4 0 0 1 .6.21 1.7 1.7 0 0 1 .42.42 1.7 1.7 0 0 1 .22.56A2 2 0 0 1 77 87.6a1.6 1.6 0 0 1-.37.48 1.4 1.4 0 0 1-.52.28 1.5 1.5 0 0 1-.64 0 1.44 1.44 0 0 1-.6-.22 1.5 1.5 0 0 1-.42-.41 1.7 1.7 0 0 1-.22-.56 2.3 2.3 0 0 1 0-.64 2 2 0 0 1 .19-.61 1.6 1.6 0 0 1 .37-.48 1.4 1.4 0 0 1 .52-.28 1.36 1.36 0 0 1 .69 0m-.07.44a.8.8 0 0 0-.44 0 .8.8 0 0 0-.33.22 1.3 1.3 0 0 0-.22.36 2 2 0 0 0-.12.42 1.6 1.6 0 0 0 0 .44 1.1 1.1 0 0 0 .11.41.9.9 0 0 0 .25.31 1.05 1.05 0 0 0 .42.16.9.9 0 0 0 .44 0 .86.86 0 0 0 .33-.23 1.2 1.2 0 0 0 .22-.35 1.63 1.63 0 0 0 .12-.87 1 1 0 0 0-.11-.4.84.84 0 0 0-.25-.31.8.8 0 0 0-.47-.16ZM77.74 86.36l2.1.3-.32 2.24-.52-.07.29-1.83-1.11-.16-.27 1.87-.49-.07ZM80 88.61a.3.3 0 0 0 .22 0 .4.4 0 0 0 .18-.2.8.8 0 0 0 .06-.16 1 1 0 0 0 0-.16v-.47c0-.1 0-.21.06-.33s0-.28.07-.45l1.86.27-.32 2.24-.5-.07.27-1.88-.86-.12c0 .19-.06.35-.08.5s0 .27-.07.37 0 .21-.07.29 0 .15-.08.21a1 1 0 0 1-.11.19.34.34 0 0 1-.15.14.6.6 0 0 1-.26.07 1.4 1.4 0 0 1-.4 0h-.21000000000000002l.06-.38h.08ZM84.79 89.15a.5.5 0 0 0 0 .13s0 0 .09 0H85l-.05.34h-.32a.43.43 0 0 1-.24-.09.29.29 0 0 1-.1-.23.84.84 0 0 1-.39.15 1.3 1.3 0 0 1-.43 0 1.3 1.3 0 0 1-.28-.08.8.8 0 0 1-.23-.16.6.6 0 0 1-.16-.53.7.7 0 0 1 .12-.32.7.7 0 0 1 .23-.18.7.7 0 0 1 .3-.06h.79a.34.34 0 0 0 .16-.06.22.22 0 0 0 .08-.15.26.26 0 0 0 0-.16.27.27 0 0 0-.1-.11.5.5 0 0 0-.15-.07h-.15a.6.6 0 0 0-.36 0 .34.34 0 0 0-.19.24H83a.76.76 0 0 1 .15-.34.7.7 0 0 1 .27-.2.9.9 0 0 1 .34-.07 2 2 0 0 1 .36 0 1.7 1.7 0 0 1 .32.08.9.9 0 0 1 .28.16.55.55 0 0 1 .17.23.52.52 0 0 1 .11.33Zm-.4-.7a.65.65 0 0 1-.29 0 2 2 0 0 0-.34 0h-.15a.5.5 0 0 0-.14 0 .2.2 0 0 0-.11.1.25.25 0 0 0 0 .15.24.24 0 0 0 0 .15.27.27 0 0 0 .11.1.4.4 0 0 0 .14.07h.32a.6.6 0 0 0 .19 0 .5.5 0 0 0 .16-.11.3.3 0 0 0 .09-.19ZM87.31 88.1l-.74-.1-.27 1.87-.5-.07.27-1.88-.77-.11v-.36l2 .28ZM87.68 87.78l.49.07-.17 1.54L89.17 88l.61.09-.32 2.24-.5-.07.22-1.55-1.18 1.4-.64-.11ZM92.05 88.78l-.75-.11-.3 1.88-.5-.07.27-1.88-.77-.11v-.37l2 .29ZM92.42 88.45l.49.07-.12.86.66.1a.8.8 0 0 1 .39.13.6.6 0 0 1 .22.2.46.46 0 0 1 .08.24 1 1 0 0 1 0 .23 1 1 0 0 1-.06.22.5.5 0 0 1-.15.21.7.7 0 0 1-.26.14 1 1 0 0 1-.42 0l-1.15-.15Zm.22 2 .64.09a.33.33 0 0 0 .24 0 .31.31 0 0 0 .13-.23.3.3 0 0 0-.06-.26.4.4 0 0 0-.22-.09l-.64-.09ZM85.3 103.33a3.74 3.74 0 1 1-3.17-4.23 3.75 3.75 0 0 1 3.17 4.23",
    className: "rules-online_svg__cls-7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 103.17a2.63 2.63 0 1 1-2.23-3 2.63 2.63 0 0 1 2.23 3",
    className: "rules-online_svg__cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.65 30.61a.58.58 0 0 1-.67.5l-10.07-1.44a.59.59 0 0 1-.5-.67.59.59 0 0 1 .67-.5l10.07 1.44a.58.58 0 0 1 .5.67",
    className: "rules-online_svg__cls-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.26 64.7 91.67 37c-.18-1.05-2.27-.75-3.48.51a39.6 39.6 0 0 1-19.61 11.36l-.43 3a43.6 43.6 0 0 0 13.12-5.47c1.91 3 5.74 2 8.14.93l2.17 13.12c-4.92 3.68-5.74 7.69-5.82 9.56-9.32 5.47-17.38 6.11-21.07 6l-.45 3.17c5.78-.12 18.17-1.86 31.2-13a1.88 1.88 0 0 0 .82-1.48",
    className: "rules-online_svg__cls-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.07 63c-.31 8.9-8.68 12.08-10.32 12.62l-.06.41c3.69.07 11.75-.57 21.07-6 .08-1.87.9-5.88 5.82-9.56l-2.17-13.12c-2.4 1.07-6.23 2.11-8.14-.93a43.6 43.6 0 0 1-13.12 5.47l-.42 2.92c3.73-.3 7.58 1.52 7.34 8.19",
    className: "rules-online_svg__cls-3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.07 63c.24-6.71-3.61-8.53-7.34-8.23l-3 20.85c1.66-.5 10.03-3.68 10.34-12.62",
    className: "rules-online_svg__cls-6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rules-online_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.33 29.64-1.57 11c6.34-2.64 12.6-5.53 18.81-8.54Z",
    className: "rules-online_svg__cls-7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "rules-online_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.07 52.48-1.92 13.43 43.7-15.76 1.89-13.23C97.37 42.39 83 47.74 68.07 52.48",
    className: "rules-online_svg__cls-7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m94.09 32.89-25 12.41-.51 3.57 35.87-14.5z",
    className: "rules-online_svg__cls-7",
    style: {
      opacity: 0.11
    }
  }));
};
export default SvgRulesOnline;